class ResourceFactory {
    switchObject;

    constructor() {
        this.switchObject = {};
    }

    create(props) {
        if (this.switchObject.hasOwnProperty(props.type)) {
            return this.switchObject[props.type](props);
        }

        throw new Error(`Resource of type ${props.type} doesn't exists`);
    }

    register(type, className) {
        this.switchObject[type] = props => new className(props);
    }
}

export default new ResourceFactory;
